<template>
  <div style="max-width: 800px; margin: 20px auto; padding: 20px; border: 1px solid #eaeaea; border-radius: 8px;">
    <h3 style="text-align: center;">第五届食育膳食技能大赛申请表</h3>

      <el-form :model="formData" :rules="rules"  style="max-width: 600px" ref="formData" label-width="auto">
      <el-form-item label="单位名称" prop="unitName">
        <el-input v-model="formData.unitName" placeholder="请输入单位名称" />
      </el-form-item>
      <el-form-item label="负责人姓名" prop="responsiblePerson">
        <el-input v-model="formData.responsiblePerson" placeholder="请输入负责人姓名" />
      </el-form-item>

      <el-form-item label="负责人职务" prop="responsiblePosition">
        <el-input v-model="formData.responsiblePosition" placeholder="请输入负责人职务" />
      </el-form-item>

      <el-form-item label="负责人电话" prop="responsiblePhone">
        <el-input v-model="formData.responsiblePhone" placeholder="请输入负责人电话" />
      </el-form-item>

      <el-form-item label="联系人姓名" prop="contactPerson">
        <el-input v-model="formData.contactPerson" placeholder="请输入联系人姓名" />
      </el-form-item>
      <el-form-item label="联系人职务" prop="contactPosition">
        <el-input v-model="formData.contactPosition" placeholder="请输入联系人职务" />
      </el-form-item>

       <el-form-item  label="联系人电话" prop="contactPhone">
         <el-input v-model="formData.contactPhone" placeholder="请输入联系人电话" />
       </el-form-item>
      <el-form-item label="联系人邮箱" prop="email">
        <el-input v-model="formData.email" type="email" placeholder="请输入联系人邮箱" />
      </el-form-item>
      <el-form-item label="单位盖章版报名表" prop="applicantSignature">
        <label for="file-upload" v-loading="loading" class="custom-file-upload">
          <i class="fa fa-cloud-upload"></i> + 上传单位盖章版报名表
        </label>

        <input  id="file-upload"  type="file" accept="image/*" @change="handleProcessImageUpload"    style="border: 0px;" />
        <img v-if="formData.applicantSignature" :src="formData.applicantSignature" alt="单位盖章版报名表" style="max-width: 300px;margin-top: 10px" />
      </el-form-item>

    </el-form>

    <div style="text-align: center; margin-top: 20px;">
      <el-button type="primary" plain @click="submitForm">
        <span v-if="formData.id==null">提交</span>
        <span v-else>修改</span>
      </el-button>
      <el-button type="info"  @click="resetForm" plain>重置</el-button>
    </div>
  </div>
  </template>

<script>

import 'element-plus/dist/index.css'
import api from "@/api/dsca";

import picApi from "@/api/competitionApplication";


export default {

  name: "compeForm",
  data() {
    return {

      loading:false,
      imageUrl: '',
      showCanvas: false,
      isDrawing: false,
      lastX: 0,
      lastY: 0,
      signatureData: null,
      lineWidth: 2,
      canvasWidth: 0,
      canvasHeight: 0,
      ratio: 1,
      formData: {
        unitName: "",
        responsiblePerson: "",
        responsiblePosition: "",
        responsiblePhone: "",
        contactPerson: "",
        contactPosition: "",
        contactPhone: "",
        email: "",
        applicantSignature: ""
      },
      rules: {
        unitName: [
          { required: true, message: '请输入单位名称', trigger: 'blur' }
        ],
        responsiblePerson: [
          { required: true, message: '请输入负责人姓名', trigger: 'blur' }
        ],
        responsiblePosition: [
          { required: true, message: '请输入负责人职位', trigger: 'blur' }
        ],
        responsiblePhone: [
            {
              required: true,
              message: '请输入负责人手机号',
              trigger: 'blur'
            },
            {
              pattern: /^1[3-9]\d{9}$/,
              message: '手机号码格式不正确',
              trigger: 'blur'
            }
        ],
        contactPerson: [
          { required: true, message: '请输入联系人姓名', trigger: 'blur' }
        ],
        contactPosition: [
          { required: true, message: '请输入联系人职位', trigger: 'blur' }
        ],
        contactPhone: [
          { required: true, message: '请输入联系人手机号', trigger: 'blur' }
          ,
          {
            pattern: /^1[3-9]\d{9}$/,
            message: '手机号码格式不正确',
            trigger: 'blur'
          }
        ],
        email:[
          { required: true, message: '请输入联系人邮箱', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
        ],
        applicantSignature:[
          { required: true, message: '上传单位盖章版报名表', trigger: 'change' }
        ],


      }
    };
  },



  methods: {
    resetForm(){
      this.formData = {
        unitName: "",
        responsiblePerson: "",
        responsiblePosition: "",
        responsiblePhone: "",
        contactPerson: "",
        contactPosition: "",
        contactPhone: "",
        email: "",
        applicantSignature: ""
      };
    },

    submitForm() {

      this.$refs.formData.validate((valid) => {
        if (valid) {
          api.submitApplication(this.formData).then(res => {

            if (res.code === 200) {
              console.log(res)
              this.formData = res.data;
              //this.$message.success({ message: '您已提交成功，请耐心等候，如有疑问请联系组委会！', center: true });

              this.$message.success({
                message: '您已提交成功，请耐心等候，如有疑问请联系组委会！',
                center: true,
                duration: 5000,
                offset: (window.innerHeight / 2) - 100,
                width: '90%'
              });
            }
          }).catch(err => {
            this.$message.error('提交失败！');
          });

        } else {
          //this.$message.error('提交失败！');
          return false;
        }
      });
    },




    // 处理制作图片上传
    handleProcessImageUpload(event) {
      this.loading=true;
      const file = event.target.files[0];
      if (file) {
        picApi.upload({file:file,watermark:false}).then(res => {
          if (res.code === 200) {
            this.formData.applicantSignature = res.data;

          }
          this.loading=false;
        });
      }
    },



    find(){
      api.find().then(
          res => {
            if (res.code === 200) {
              if (res.data!=null){
                this.formData = res.data;
              }
            }else {
               if (res.code==208 || res.code==209 ||  res.code==219){

                 this.$message.error({
                   message: res.message,
                   center: true,
                   duration: 5000,
                   offset: (window.innerHeight / 2) - 100,
                   width: '90%'
                 });

                 this.$router.push('/videoInfo');
               }
            }
          }
      )
    }

  },
  created() {
    //this.$message.success('ElementPlus 已成功注册！')
    this.find();
  }
};
</script>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}



.custom-file-upload {
  display: inline-block;
  padding: 2px 20px;
  background-color: #67c23a;
  color: white;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.3s;
  font-size: 12px;
}

.custom-file-upload:hover {
  background: #0b7dda;
}

#file-upload {
  display: none;
}
</style>
